import prepareTasksCreateData from './prepareTasksCreateData';
import prepareTasksUpdateData from './prepareTasksUpdateData';
import prepareTasksDeleteData from './prepareTasksDeleteData';
import prepareLinksCreateData from './prepareLinksCreateData';
import prepareLinksUpdateData from './prepareLinksUpdateData';
import prepareTaskResources from './prepareTaskResources';

export default {
  prepareTasksCreateData,
  prepareTasksUpdateData,
  prepareTasksDeleteData,
  prepareLinksCreateData,
  prepareLinksUpdateData,
  prepareTaskResources,
};
